import { Utils } from "helpers/utils";
import { MemberRole, WpActionTypes, WpEmoji, WpPostType, WpSliceData, WpStatus } from "./wpTypes";
import { SKeys } from "const";

const initTagFilter = () => {
  try {
    const init_tag = localStorage.getItem(SKeys.EmbInitWpTag);
    if (!init_tag) return [];
    const data = JSON.parse(init_tag);
    localStorage.removeItem(SKeys.EmbInitWpTag);
    return data;
  } catch (e) {
    console.error(e);
  }
}

const initFilterNotClose = () => {
  try {
    const init_filterNotClose = localStorage.getItem(SKeys.InitWpFilterNoClose);
    if (!init_filterNotClose) return true;
    localStorage.removeItem(SKeys.InitWpFilterNoClose);
    return false;
  } catch (e) {
    console.error(e);
    return true;
  }
}

const INIT_STATE: WpSliceData = {
  activePostInfo: {
    postId: null,
    title: "",
    icon: "",
    abbrName: '➕',
    abbrFore: "#000000",
    abbrBack: "#C0C0C0",
    tags: [],
    flag: false,
    snooze: false,
    isYourPost: false,
    canDeletePost: false,
    canChangeStatus: false,
    youIsMember: true,
    status: WpStatus.Open,
    statusById: null,
    statusDate: null,
    statusRemark: null,
    statusByName: null,
  },
  // activePostId: null,
  // activePostTitle: null,
  // activePostAbbr: '➕',
  // activePostAbbrFore: "#000000",
  // activePostAbbrBack: "#C0C0C0",
  // activePostTags: [],
  activeMemberRole: Utils.GetMemberRoleFromStorage(),

  titleLoading: false,
  titleErrMsg: null,
  titles: [],

  converLoading: false,
  converErrMsg: null,
  convers: [],
  roleUnread: {
    memberId: -1,
    reloadTitle: false,
    unreadOwner: 0,
    unreadFollower: 0,
    unreadTagMe: 0,
    unreadMyPost: 0,
    unreadFlag: 0,
    unreadOrganize: 0,
    unreadPersonFollow: 0,
    unreadObserver: 0,
  },
  tagFilterSelected: initTagFilter(),
  filterNotClose: initFilterNotClose(),
}



const apiErr = (state: WpSliceData, payload: any): WpSliceData => {
  console.log('apiError:', payload);
  if (payload.type == WpActionTypes.LOAD_POST_TITLE) {
    return { ...state, titleLoading: false, titleErrMsg: payload.errMsg };
  }
  return { ...state };
}

const apiOk = (state: WpSliceData, payload: any): WpSliceData => {
  const type = payload.type as WpActionTypes;
  // console.log('apiOk:', payload);

  if (type == WpActionTypes.LOAD_POST_TITLE) {
    // console.log('Slice.WpActionTypes.LOAD_POST_TITLE:', payload.data);
    return {
      ...state,
      titleLoading: false,
      titleErrMsg: "",
      titles: payload.data,
    };
  }

  if (type == WpActionTypes.SET_ACTIVE_POSTID) {
    // console.log('WpActionTypes.SET_ACTIVE_POSTID:', payload);
    return {
      ...state,
      converLoading: false,
      converErrMsg: "",
      convers: payload.data,
    }
  }

  if (type == WpActionTypes.LOAD_POST_INFO) {
    return {
      ...state,
      activePostInfo: payload.data,
      // activePostTags: payload.data,
    }
  }

  if (type == WpActionTypes.GET_ROLE_UNREAD_COUNT) {
    return {
      ...state,
      roleUnread: payload.data
    }
  }




  return { ...state };
}

const WpSlice = (state: WpSliceData = INIT_STATE, action: any): WpSliceData => {
  const type = action.type as WpActionTypes;
  if (type == WpActionTypes.API_ERR) return apiErr(state, action.payload);
  if (type == WpActionTypes.API_OK) return apiOk(state, action.payload);


  if (type == WpActionTypes.SET_ACTIVE_POSTID) {
    //  console.log('SET_ACTIVE_POSTID:', action.payload);
    // console.log('action.payload.activePostInfo.postId ? true : false = ' + (action.payload.activePostInfo.postId ? true : false));
    return {
      ...state,
      activePostInfo: action.payload.activePostInfo,
      // activePostId: action.payload.activePostId,
      // activePostTitle: action.payload.activePostTitle,
      // activePostAbbr: action.payload.activePostAbbr,
      // activePostAbbrFore: action.payload.activePostAbbrFore,
      // activePostAbbrBack: action.payload.activePostAbbrBack,

      converLoading: action.payload.activePostInfo.postId ? true : false,
      converErrMsg: "",
      convers: [],
    }
  }

  if (type == WpActionTypes.SET_DRAFT_POST) {
    const { postId, draft } = action.payload;
    // console.log('WpActionTypes.SET_DRAFT_POST:', action.payload);
    // check if postId exists
    const exists = state.titles.some(e => e.postId === postId);
    if (!exists) return state; // no changes → return same state object

    return {
      ...state,
      titles: state.titles.map(e => e.postId === postId ? ({ ...e, draft: draft }) : ({ ...e }))
    }
  }

  if (type == WpActionTypes.SET_POST_INFO_ON_SIGNALR) {
    const { postInfo, lastChatText, lastChatTime, lastChatImg, unreadCount, memberRoles } = action.payload;
    // console.log('SetPostInfoSlice:', { postInfo, lastChatText, lastChatTime, lastChatImg, unreadCount, memberRoles });
    const activeRole1 = state.activeMemberRole;
    const activeRole2 = activeRole1 == MemberRole.Organize ? MemberRole.PersonFollow : -1;
    const allRole = activeRole1 == MemberRole.All;
    //const onView = allRole || memberRoles.find((t: any) => (t == activeRole1 || t == activeRole2));
    const onView = memberRoles.find((t: any) =>
      (t == activeRole1 || t == activeRole2)
      || (allRole && t !== MemberRole.Observer)
    );

    // console.log('check post display:', { onView, memberRoles, activeRole1, activeRole2, allRole });
    if (!onView) {
      console.log('new message not on selected role');
      return { ...state };
    }


    const index = state.titles.findIndex(t => t.postId === postInfo.postId);
    // console.log('index = ' + index);
    let newTitles = [...state.titles];
    if (index !== -1) { // found existing
      const existing = {
        ...newTitles[index],
        title: postInfo.title,
        lastChatText: lastChatText,
        lastChatImg: lastChatImg,
        lastChatDate: lastChatTime,
        abbrName: postInfo.abbrName,
        abbrFore: postInfo.abbrFore,
        abbrBack: postInfo.abbrBack,
        status: postInfo.status,
        unread: unreadCount,
      };
      newTitles.splice(index, 1);
      newTitles.unshift(existing);
    } else { // not found
      newTitles.unshift({
        ...postInfo,
        title: postInfo.title,
        lastChatImg: lastChatImg,
        lastChatDate: lastChatTime,
        abbrName: postInfo.abbrName,
        abbrFore: postInfo.abbrFore,
        abbrBack: postInfo.abbrBack,
        status: postInfo.status,
        unread: unreadCount,
      });
    }

    return {
      ...state,
      activePostInfo: state.activePostInfo.postId == postInfo.postId ? postInfo : state.activePostInfo,
      titles: newTitles
    };
  }

  if (type == WpActionTypes.UPDATE_POST_UNREAD_COUNT) {
    const { postId, memberId, unreadCount } = action.payload;
    // console.log('UPDATE_POST_UNREAD_COUNT:', action.payload);
    return {
      ...state,
      titles: state.titles.map((title) => title.postId === postId ? { ...title, unread: unreadCount } : title),
      convers: (state.convers ?? []).map((c) => c.postIdParent == postId ? { ...c, isRead: true } : c),
    }
  }

  if (type == WpActionTypes.LOAD_POST_TITLE) {
    return {
      ...state,
      titleLoading: true,
    }
  }

  if (type == WpActionTypes.APPEND_POST_CONVER) {
    // console.log('APPEND_POST_CONVER:', action);
    const conv2add = action.payload.postData;

    if (conv2add == null || conv2add.length <= 0) return { ...state };
    if (conv2add[0].postIdParent != state.activePostInfo.postId) return { ...state };

    return {
      ...state,
      convers: [...state.convers, ...conv2add]
    }
    // console.log('existing state:', state.activePostInfo.postId);
    // return {
    //   ...state,
    //   convers: [...state.convers, ...action.payload.postData]
    // }
    // return {
    //   ...state,
    //   convers: [
    //     ...state.convers,
    //     ...action.payload.postData.filter(
    //       (post: any) => post.postIdParent === state.activePostInfo.postId
    //     )
    //   ]
    // };
  }

  if (type == WpActionTypes.SET_ACTIVE_MEMBERROLE) {
    Utils.SetMemberRoleToStorage(action.payload.memberRole);
    return { ...state, activeMemberRole: action.payload.memberRole }
  }

  if (type == WpActionTypes.SET_FILTER_SELECTED) {
    const { tagSelected, filterNotClose } = action.payload;
    // console.log(action.payload);
    return {
      ...state,
      //tagFilterSelected: action.payload.tagSelected,
      tagFilterSelected: tagSelected === undefined ? state.tagFilterSelected : tagSelected,
      filterNotClose: filterNotClose === undefined ? state.filterNotClose : filterNotClose
    }
  }

  if (type == WpActionTypes.SET_FLAG) {
    const { postId, flag } = action.payload;
    return {
      ...state,
      activePostInfo: {
        ...state.activePostInfo,
        flag: state.activePostInfo.postId === postId ? flag : state.activePostInfo.flag
      },
      titles: state.titles.map(e => e.postId === postId ? { ...e, flag: flag } : { ...e })
    };
  }

  if (type == WpActionTypes.SET_SNOOZE) {
    const { postId, snooze } = action.payload;
    // console.log('WpActionTypes.SET_SNOOZE:', { postId, snooze });
    return {
      ...state,
      activePostInfo: {
        ...state.activePostInfo,
        snooze: state.activePostInfo.postId === postId ? snooze : state.activePostInfo.snooze
      },
      titles: state.titles.map(e => e.postId === postId ? { ...e, snooze: snooze } : { ...e })
    };
  }

  if (type == WpActionTypes.SET_UNREAD) {
    const { postId, unread } = action.payload;
    // console.log('WpActionTypes.SET_SNOOZE:', { postId, snooze });
    return {
      ...state,
      titles: state.titles.map(e => e.postId === postId ? { ...e, unread: unread } : { ...e })
    };
  }

  if (type == WpActionTypes.TOGGLE_POST_EMOJI) {
    const { postIdParent, postId, emojiName, emojiIcon, isAdd, memberName } = action.payload;
    if (postIdParent !== state.activePostInfo?.postId) return { ...state }
    // console.log('Reducer TOGGLE_POST_EMOJI:', { postIdParent, postId, emojiName, emojiIcon, isAdd, memberName });
    return {
      ...state,
      convers: state.convers.map(con => {
        if (con.postId !== postId) return con;

        const emojis = con.emojis ?? [];
        const emojiIndex = emojis.findIndex(t => t.nm === emojiName);
        // console.log('emojiIndex = ' + emojiIndex);

        let updatedEmojis: WpEmoji[];
        // console.log('updatedEmojis prev:', emojis);

        if (emojiIndex === -1 && isAdd) {
          // Not found and need to add
          updatedEmojis = [...emojis, { nm: emojiName, ji: emojiIcon, mbr: memberName }];
        } else if (emojiIndex !== -1) {
          const emoji = emojis[emojiIndex];
          const members = emoji.mbr.split("|");

          const newMembers = isAdd
            ? Array.from(new Set([...members, memberName]))
            : members.filter(x => x !== memberName);

          // console.log('newMembers:', newMembers);

          // Update emoji immutably
          const updatedEmoji = { ...emoji, mbr: newMembers.join("|") };

          // Update emojis array immutably
          updatedEmojis = emojis.map((e, i) => (i === emojiIndex ? updatedEmoji : e));
        } else {
          updatedEmojis = emojis;
        }
        // console.log('updatedEmojis after:', updatedEmojis);
        return { ...con, emojis: updatedEmojis };
      })
    };
  }

  if (type == WpActionTypes.MARK_POST_UNSEND) {
    const { postIdParent, postId, isDelPost } = action.payload;
    // console.log('Reducer.MARK_POST_UNSEND:', { postIdParent, postId, isDelPost });
    if (isDelPost) {
      return {
        ...state,
        titles: state.titles.filter(x => x.postId !== postIdParent)
      }
    } else {
      if (postIdParent !== state.activePostInfo?.postId) return { ...state }
      return {
        ...state,
        convers: state.convers.map(con => con.postId === postId ? { ...con, isUnsend: true } : con)
      }
    }
  }

  if (type === WpActionTypes.CHANGE_POST_STATUS) {
    const { postIdParent, status } = action.payload;
    return {
      ...state,
      titles: state.titles.map(e1 => e1.postId === postIdParent ? { ...e1, status: status } : e1)
    }
  }

  if (type === WpActionTypes.SET_IS_EMB_CHAT_ONLY) {
    return {
      ...state,
      isEmbChatOnly: action.payload.isEmbChatOnly
    }
  }

  // default
  return { ...state }
}

export default WpSlice;